export const DIAGNOSTIC_TYPE_FETCHING = 'DIAGNOSTIC_TYPE_FETCHING';
export const DIAGNOSTIC_TYPE_FETCHED = 'DIAGNOSTIC_TYPE_FETCHED';
export const DIAGNOSTIC_TYPE_FETCHING_FAILED = 'DIAGNOSTIC_TYPE_FETCHING_FAILED';
export const DIAGNOSTIC_SUPPORT_FETCHING_FAILED = 'DIAGNOSTIC_SUPPORT_FETCHING_FAILED';
export const DIAGNOSTIC_SUPPORT_FETCHED = 'DIAGNOSTIC_SUPPORT_FETCHED';

export const ANALYZER_UNIT_FETCHING = 'ANALYZER_UNIT_FETCHING';
export const ANALYZER_UNIT_FETCHED = 'ANALYZER_UNIT_FETCHED';
export const ANALYZER_UNIT_FETCHING_FAILURE = 'ANALYZER_UNIT_FETCHING_FAILURE';

export const DATE_FETCHING = 'DATE_FETCHING';
export const DATE_FETCHED = 'DATE_FETCHED';
export const DATE_FETCHING_FAILURE = 'DATE_FETCHING_FAILURE';

export const PHOTOCAL_EXPORT_CSV_FETCHING = 'PHOTOCAL_EXPORT_CSV_FETCHING';
export const PHOTOCAL_EXPORT_CSV_FETCHED = 'PHOTOCAL_EXPORT_CSV_FETCHED';
export const PHOTOCAL_EXPORT_CSV_FETCHING_FAILED = 'PHOTOCAL_EXPORT_CSV_FETCHING_FAILED';

export const DIAGONSTIC_DATA_FETCHING = 'DIAGONSTIC_DATA_FETCHING';
export const DIAGONSTIC_DATA_RESET = 'DIAGONSTIC_DATA_RESET';
export const DIAGONSTIC_DATA_FETCHED = 'DIAGONSTIC_DATA_FETCHED';
export const DIAGONSTIC_DATA_FETCHING_FAILED = 'DIAGONSTIC_DATA_FETCHING_FAILED';

export const DIAG_TYPE_FILTER_RESULT="DIAG_TYPE_FILTER_RESULT";
export const DIAG_TYPE_FILTER_OPTIONS="DIAG_TYPE_FILTER_OPTIONS";
export const ANALYZER_FILTER_RESULT="ANALYZER_FILTER_RESULT";
export const FILTER_DATE_RESULT = 'FILTER_DATE_RESULT';
export const ANALYZER_FILTER_SHOW = 'ANALYZER_FILTER_SHOW'
export const PHOTOCAL_FILTERS_SHOW = 'PHOTOCAL_FILTERS_SHOW'
export const PHOTOCAL_FILTERS_WAVELENGTH_SHOW = 'PHOTOCAL_FILTERS_WAVELENGTH_SHOW'
export const PHOTOCAL_CUVETTE_FILTER_RESULT = 'PHOTOCAL_CUVETTE_FILTER_RESULT';
export const PHOTOCAL_CUVETTE_FILTER_RESULT_RESET = 'PHOTOCAL_CUVETTE_FILTER_RESULT_RESET';
export const PHOTOCAL_FILTERED_DATA = 'PHOTOCAL_FILTERED_DATA';
export const PHOTOCAL_WAVELENGTH_FILTER_DATA = 'PHOTOCAL_WAVELENGTH_FILTER_DATA';
export const ANALYZER_UNIT_OPTIONS="ANALYZER_UNIT_OPTIONS";
export const DATE_OPTIONS = 'DATE_OPTIONS';
export const PHOTOCAL_CUVETTE_OPTIONS = 'PHOTOCAL_CUVETTE_OPTIONS';
export const PHOTOCAL_WAVELENGTH_OPTIONS = 'PHOTOCAL_WAVELENGTH_OPTIONS';
export const PHOTOCAL_GRAPH_DATA = 'PHOTOCAL_GRAPH_DATA';

export const PHOTOCAL_MONITOR = "Photocal Monitor"
export const ISE = "ISESelectivity"
export const DEFAULT_OPTION = 'ALL';

export const ISE_CONC = "CONC";
export const ISE_CHECK_SOLU_VOLTAGE = "CheckSolutionVoltage";
export const ISE_MID_SOLU_VOLTAGE = "MidSolutionVoltage";
export const DEVICE_DETAILS = "DEVICE_DETAILS";

export const MAINTANANCE_DATA = "MAINTANANCE_DATA";

// PipettorMatch Report Constants
export const PIPETTOR_MATCH_REPORT_FETCHING = 'PIPETTOR_MATCH_REPORT_FETCHING';
export const PIPETTOR_MATCH_REPORT_FETCHED = 'PIPETTOR_MATCH_REPORT_FETCHED';
export const PIPETTOR_MATCH_REPORT_FETCHING_FAILED = 'PIPETTOR_MATCH_REPORT_FETCHING_FAILED';

// CarryOver Report Constants
export const CARRYOVER_REPORT_FETCHING = 'CARRYOVER_REPORT_FETCHING';
export const CARRYOVER_REPORT_FETCHED = 'CARRYOVER_REPORT_FETCHED';
export const CARRYOVER_REPORT_FETCHING_FAILED = 'CARRYOVER_REPORT_FETCHING_FAILED';
export const FILTER_DATE_RESULT_RESET = 'FILTER_DATE_RESULT_RESET';
export const ANALYZER_FILTER_RESULT_RESET="ANALYZER_FILTER_RESULT_RESET";

export const PIPETTOR_MATCH = "PipettorMatch";

export const PIPETTOR_MATCH_DATA_FETCHING = 'PIPETTOR_MATCH_DATA_FETCHING';
export const PIPETTOR_MATCH_DATA_FETCHED = 'PIPETTOR_MATCH_DATA_FETCHED';
export const PIPETTOR_MATCH_DATA_FETCHING_FAILED = 'PIPETTOR_MATCH_DATA_FETCHING_FAILED';

// Pagination constants for PipettorMatch
export const PIPETTOR_MATCH_LOAD_MORE = 'PIPETTOR_MATCH_LOAD_MORE';
export const PIPETTOR_MATCH_DATA_RESET = 'PIPETTOR_MATCH_DATA_RESET';

// CarryoverSummary Constants
export const CARRYOVER = "CarryOver";
export const SIMPLE_PIPETTOR = "Sample Pipettor";

export const CARRYOVER_SUMMARY_DATA_FETCHING = 'CARRYOVER_SUMMARY_DATA_FETCHING';
export const CARRYOVER_SUMMARY_DATA_FETCHED = 'CARRYOVER_SUMMARY_DATA_FETCHED';
export const CARRYOVER_SUMMARY_DATA_FETCHING_FAILED = 'CARRYOVER_SUMMARY_DATA_FETCHING_FAILED';

// Pagination constants for CarryoverSummary
export const CARRYOVER_SUMMARY_LOAD_MORE = 'CARRYOVER_SUMMARY_LOAD_MORE';
export const CARRYOVER_SUMMARY_DATA_RESET = 'CARRYOVER_SUMMARY_DATA_RESET';

export const LOWVOLUME = "LowVolume";

export const LOWVOLUME_DATA_FETCHING = 'LOWVOLUME_DATA_FETCHING';
export const LOWVOLUME_DATA_FETCHED = 'LOWVOLUME_DATA_FETCHED';
export const LOWVOLUME_DATA_FETCH_FAILED = 'LOWVOLUME_DATA_FETCH_FAILED';

export const LOWVOLUME_REPORT_FETCHING = 'LOWVOLUME_REPORT_FETCHING';
export const LOWVOLUME_REPORT_FETCHED = 'LOWVOLUME_REPORT_FETCHED';
export const LOWVOLUME_REPORT_FETCH_FAILED = 'LOWVOLUME_REPORT_FETCH_FAILED';

export const LOWVOLUME_LOAD_MORE = 'LOWVOLUME_LOAD_MORE';
export const LOWVOLUME_DATA_RESET = 'LOWVOLUME_DATA_RESET';

export const SYSTEM_CHECK = "SystemCheck";

export const SYSTEM_CHECK_DATA_FETCHING = 'SYSTEM_CHECK_DATA_FETCHING';
export const SYSTEM_CHECK_DATA_FETCHED = 'SYSTEM_CHECK_DATA_FETCHED';
export const SYSTEM_CHECK_DATA_FETCH_FAILED = 'SYSTEM_CHECK_DATA_FETCH_FAILED';
export const SYSTEM_CHECK_REPORT_FETCHING = 'SYSTEM_CHECK_REPORT_FETCHING';
export const SYSTEM_CHECK_REPORT_FETCHED = 'SYSTEM_CHECK_REPORT_FETCHED';
export const SYSTEM_CHECK_REPORT_FETCH_FAILED = 'SYSTEM_CHECK_REPORT_FETCH_FAILED';

export const SYSTEM_CHECK_LOAD_MORE = 'SYSTEM_CHECK_LOAD_MORE';
export const SYSTEM_CHECK_DATA_RESET = 'SYSTEM_CHECK_DATA_RESET';

export const SYSTEM_CHECK_DISPLAY_MAP = {
  'SWRatio': 'Substrate: Washed Ratio *',
  'Eff': 'Wash Efficiency',
  'SubstrateRatio': 'Substrate Ratio',
  'Cleaned': 'Clean'
};

// API Response Keys
export const HAS_MORE_KEY = 'hasMore';
export const DATA_KEY = 'data';
export const PAGE_SIZE_KEY = 'pageSize';
export const NEXT_CURSOR_KEY = 'nextCursor';
 